import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "RecentVacancies",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getRecentVacancies,
  getRecentVacanciesError,
  getRecentVacanciesSuccess,
} = slice.actions;

reducerRegistry.register("recentVacancies", reducer);
